export const GT_RAIL_AND_FLY: string = 'GT08-ARDE/ST08-RAFL';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/types/rail-and-fly-type.ts